export default {
  distributions: [],
  isPreviewOpen: false,
  distribution: {},
  messageTemplates: [],
  whatsappIntegrations: [],
  queryParams: {
    rowsNumber: 0
  },
  distributionCustomers: [],
  totalDistributionCustomers: 0,
  reminderAtFields: {
    days: 3,
    hours: null
  }
};
